import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { IRolesState, IRole } from "./types";

const initialState: IRolesState = {
  roles: [],
  isLoaded: false,
};

export const rolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    setRoles: (state, action: PayloadAction<IRole[]>) => {
      state.roles = action.payload;
      state.isLoaded = true;
    },
    clearRoles: (state) => {
      state.roles = [];
      state.isLoaded = false;
    },
  },
});

export const { setRoles, clearRoles } = rolesSlice.actions;
export default rolesSlice.reducer;
